import Login from './Login'
import Logout from './Logout'
import ForgotPassword from './ForgotPassword'
import PasswordResetToken from './PasswordResetToken'
import SignUp from './SignUp'

export { Login, Logout, ForgotPassword, PasswordResetToken, SignUp }



// WEBPACK FOOTER //
// ./src/views/login/index.js